var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{ref:"transition",attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut","mode":"out-in","appear":"","duration":"200"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }